/// <amd-module name="typeahead/core/message/SuggestionListSelectedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {Suggestion} from "typeahead/core/Suggestion";

export class SuggestionListSelectedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.suggestionlist_selected";
    }

    constructor(private suggestion: Suggestion, private lob: string, private domElementId: string) {}

    public getTopic(): string {
        return SuggestionListSelectedMessage.getTopic();
    }

    public getSuggestion(): Suggestion {
        return this.suggestion;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getLob(): string {
        return this.lob;
    }
}
